import React from 'react';
import styles from 'css_modules/NotificationLogo.module.css';

import logo from 'assets/svg/2_notification_bell.svg';
import logo_zero from 'assets/svg/2_notification_bell_zero.svg';

export const NotificationLogo = ({
    user,
    notifications,
    display = true,
    showNotifications,
    setShowNotifications
}) => {

    const safeNotifications = Array.isArray(notifications) ? notifications : [];

    const totalCount = display ? safeNotifications.length : 0;

    const unreadCount = display
        ? safeNotifications.filter(n => !n.is_read).length
        : 0;

    const displayCount = unreadCount > 0 ? unreadCount : totalCount;

    const isGray = unreadCount === 0;

    const badgeText = displayCount > 99 ? '99+' : displayCount;

    const currentLogo = totalCount === 0 ? logo_zero : logo;
    
    if (display === false){
        return (<></>)
    }
    return (
        <div className={styles.container}>
            <div
                className={`${styles.logoWrapper} ${showNotifications ? styles.active : ''}`}
                onClick={() => display && setShowNotifications(!showNotifications)}
            >
                <img
                    src={currentLogo}
                    alt="notifications"
                    className={styles.logo}
                />

                <span className={`${styles.badge} ${isGray ? styles.gray : ''}`}>
                    {badgeText}
                </span>
            </div>
        </div>
    );
};